import { useCallback, useState } from 'react'
import type { UserError } from '../../store/app'
import type { ToastData } from './Toast'
import { userErrorToToast } from './toast-utils'

let toastIdCounter = 0

export function useToast() {
  const [toasts, setToasts] = useState<ToastData[]>([])

  const addToast = useCallback((toast: Omit<ToastData, 'id'>) => {
    const id = `toast-${++toastIdCounter}`
    setToasts((prev) => [...prev, { ...toast, id }])
    return id
  }, [])

  const dismissToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id))
  }, [])

  const showError = useCallback((error: UserError) => {
    return addToast(userErrorToToast(error))
  }, [addToast])

  const clearAll = useCallback(() => {
    setToasts([])
  }, [])

  return {
    toasts,
    addToast,
    dismissToast,
    showError,
    clearAll,
  }
}
